import { useDispatch } from "react-redux";
import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect";
import { UPDATE_FILTER } from "@/redux/types/auth.types";
import useFilterStore from "@/stores/useFilterStore";
import classes from "../filter.module.scss";

const UNIT_MEASUREMENT_OPTIONS = [
	{ value: "kg_l", label: "Kg - L" },
	{ value: "gr_cc", label: "g - cc" },
	{ value: "ton_kl", label: "Ton - KL" },
];

const FilterUnitMeasurement = () => {
	const dispatch = useDispatch();
	const { filter, updateFilter } = useFilterStore();

	const handleChange = (value) => {
		const newFilter = { ...filter, unit_measurement: value || "kg_l" };

		dispatch({ type: UPDATE_FILTER, payload: { filter: newFilter } });
		updateFilter({ unit_measurement: value || "kg_l" });
	};

	return (
		<div className={classes.unitMeasurementSection} style={{ display: "none" }}>
			<h4>Unidad de medida</h4>
			<CustomInputSelect
				name="unit_measurement"
				options={UNIT_MEASUREMENT_OPTIONS}
				value={filter?.unit_measurement || "kg_l"}
				onChange={handleChange}
				placeholder="Seleccionar unidad"
				size="sm"
				col={12}
				isClearable={false}
			/>
		</div>
	);
};

export default FilterUnitMeasurement;
